module.exports = __webpack_public_path__ + "static/media/map-2.5491efe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-2.png
// module id = 1159
// module chunks = 28